import { isLocked, isOpen } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";

import { isPlatformFourOhUser } from "./isPlatformFourOhUser";

const AI_ADS_CLAIM = "AdIntAIAds";

export type AiInsightsAccessParams = {
    domain: string;
    isUSState?: boolean;
};

export type AiInsightsAccess = {
    canShowCard: boolean;
    canFetchTraffic: boolean;
    canFetchAds: boolean;
    isTrafficLocked: boolean;
    isAdsLocked: boolean;
    isUpgrade: boolean;
};

export const getAiInsightsAccess = ({ domain, isUSState = false }: AiInsightsAccessParams): AiInsightsAccess => {
    const hasDomain = Boolean(domain);
    const isTrafficOpen = isOpen(swSettings.components.AIRefferrals);
    const isAdsOpen = isOpen(swSettings.components[AI_ADS_CLAIM]);
    const hasTrafficHook = isLocked(swSettings.components.AIRefferrals);
    const hasAdsHook = isLocked(swSettings.components[AI_ADS_CLAIM]);
    const canShowCard = hasDomain && isPlatformFourOhUser(swSettings);
    const isUpgrade = canShowCard && !isTrafficOpen && !isAdsOpen && !hasTrafficHook && !hasAdsHook;
    const isNotUSSate = canShowCard && !isUSState;

    return {
        canShowCard,
        canFetchTraffic: isNotUSSate && isTrafficOpen,
        canFetchAds: isNotUSSate && isAdsOpen,
        isTrafficLocked: isNotUSSate && hasTrafficHook,
        isAdsLocked: isNotUSSate && hasAdsHook,
        isUpgrade,
    };
};

export const getCanShowAiInsightsCard = (domain: string): boolean => getAiInsightsAccess({ domain }).canShowCard;
